// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const donkey = defineModel({
  id: "donkey",
  scale: 2.05, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Donkey",
  tags: ["creature","donkey","low-poly","age-of-mcp","future"],
  summary: "A donkey — a tough little pack and cart animal.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.12,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.1, 5), color: "#9a9690", position: [0.06, 0.05, 0.035] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#5a564f", position: [0.06, 0.006, 0.035] },
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.1, 5), color: "#9a9690", position: [0.06, 0.05, -0.035] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#5a564f", position: [0.06, 0.006, -0.035] },
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.1, 5), color: "#9a9690", position: [-0.06, 0.05, 0.035] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#5a564f", position: [-0.06, 0.006, 0.035] },
      { geometry: new THREE.CylinderGeometry(0.0095, 0.008, 0.1, 5), color: "#9a9690", position: [-0.06, 0.05, -0.035] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.011, 0.012, 5), color: "#5a564f", position: [-0.06, 0.006, -0.035] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#9a9690", position: [0, 0.13, 0], scale: [1.7, 1, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.026, 0.07, 6), color: "#aaa6a0", position: [0.085, 0.155, 0], rotation: [0, 0, -0.7] },
      { geometry: new THREE.BoxGeometry(0.07, 0.034, 0.032), color: "#aaa6a0", position: [0.13, 0.175, 0], rotation: [0, 0, -0.2] },
      { geometry: new THREE.BoxGeometry(0.022, 0.024, 0.026), color: "#cfcabd", position: [0.162, 0.16, 0] },
      { geometry: new THREE.ConeGeometry(0.011, 0.05, 4), color: "#9a9690", position: [0.108, 0.215, 0.016], rotation: [0.25, 0, 0.1] },
      { geometry: new THREE.ConeGeometry(0.011, 0.05, 4), color: "#9a9690", position: [0.108, 0.215, -0.016], rotation: [-0.25, 0, 0.1] },
      { geometry: new THREE.BoxGeometry(0.06, 0.022, 0.012), color: "#4a463f", position: [0.06, 0.182, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#15110c", position: [0.14, 0.182, 0.018] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#15110c", position: [0.14, 0.182, -0.018] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.06, 4), color: "#9a9690", position: [-0.103, 0.092, 0], rotation: [0, 0, 2.3] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#4a463f", position: [-0.127, 0.062, 0], scale: [0.8, 1.2, 0.8] },
    ],
  animations: [],
});
